<script>
export default {
    functional: true,
    props: {
        column: Object,
        row: Object,
    },
    render(h, { props }) {
        const { column, row } = props;
        const cell = column.rowTemplate
            ? column.rowTemplate({
                  // Use slot to render cell value
                  ...row,
                  cell: row.displayData[column.name],
                  cells: row.displayData,
                  [column.field]: row.displayData[column.name],
              })
            : row.displayData[column.name];

        const title = column.rowTemplate ? '' : cell;

        let elementAttrs, vnodes;
        if (typeof cell === 'object') {
            elementAttrs = {};
            vnodes = cell;
        } else {
            elementAttrs = {
                domProps: {
                    innerHTML: cell ?? '',
                },
            };
            vnodes = undefined;
        }

        return h(
            'td',
            {
                class: !column.wrapText ? 'flex-table-no-wrap' : '',
                style: {
                    width: column.width,
                },
                attrs: {
                    title,
                },
                ...elementAttrs,
            },
            vnodes,
        );
    },
};
</script>
